import { favoriteProfessionalsAdapter } from './favoriteProfessionalsAdapter';
import {
  favoriteProfessionalsApi,
  IGetFavoriteProfessionalsParams,
} from './favoriteProfessionalsApi';
import { IFavoriteProfessional } from './favoriteProfessionalsTypes';

async function getFavoriteProfessionals(
  params: IGetFavoriteProfessionalsParams,
): Promise<IFavoriteProfessional[]> {
  const favoriteProfessionalsAPI = await favoriteProfessionalsApi.getFavoriteProfessionals(params);

  return favoriteProfessionalsAPI.map(favoriteProfessionalsAdapter.toFavoriteProfessional);
}

export const favoriteProfessionalsService = {
  getFavoriteProfessionals,
};
